<template>
  <v-app
    id="inspire"
    v-resize="onResize"
  >
    <v-navigation-drawer
      v-model="drawer"
      fixed
      clipped
      class="grey lighten-4"
      app
    >
      <aplayer
        ref="player"
        width="800px"
        :is-mini-mode="true"
        :listmaxheight="maxListHeight"
        repeat="repeat-all"
        :autoplay="true"
        :controls="false"
        :list-folded="false"
        :show-list="true"
        :list="audioList"
        :music="audioInfo"
        @update:music="updateMusic"
        @ended="onended"
        @play="onPlayPause"
        @pause="onPlayPause"
      />
    </v-navigation-drawer>
    <component
      :is="toolbarType"
      :value="true"
      color="amber"
      app
      absolute
      clipped-left
    >
      <v-toolbar-side-icon @click.native="drawer = !drawer" />
      <v-btn
        fab
        dark
        small
        @click="toggle"
      >
        <v-icon>{{ playIcon }}</v-icon>
      </v-btn>
      <v-btn
        v-for="rateOpt in playbackOptions"
        :key="rateOpt.rate"
        fab
        dark
        small
        :color="playbackRate == rateOpt.rate ? rateOpt.color : 'green lighten-4'"
        @click="changePlayRate(rateOpt.rate)"
      >
        {{ rateOpt.rate }}
      </v-btn>

      <v-btn
        fab
        dark
        small
        @click="$router.push('/question')"
      >
        <v-icon>live_help</v-icon>
      </v-btn>
    </component>
    <v-content>
      <v-btn
        v-if="!isLargeScreen"
        style="margin-bottom: 8em; opacity: .6"
        fixed
        color="amber"
        dark
        small
        absolute
        bottom
        right
        fab
        @click="toggle"
      >
        <v-icon>
          {{ playIcon }}
        </v-icon>
      </v-btn>
      <v-container
        fluid
        fill-height
        class="grey lighten-4"
      >
        <v-btn
          v-if="isLargeScreen"
          color="pink"
          dark
          small
          absolute
          center
          right
          fab
          @click="toggle"
        >
          <v-icon>{{ playIcon }}</v-icon>
        </v-btn>
        <v-btn
          v-if="isLargeScreen"
          color="pink"
          dark
          small
          absolute
          center
          left
          fab
          @click="toggle"
        >
          <v-icon>{{ playIcon }}</v-icon>
        </v-btn>
        <Notebook
          :msg="lrc"
          :is-large-screen="isLargeScreen"
        />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Aplayer from 'vue-aplayer';
import sortUtil from '@/util';
import { VToolbar, VBottomNav } from 'vuetify/lib';

import Notebook from '@/components/Notebook';

const lrcData = require('@/assets/lrc.json');

const findLrc = (title) => {
  const num = Number(title.split('-')[1]);
  return lrcData[`S-${num}.flac`];
};

const radioData = require('@/assets/all.json')
  .sort((a, b) => sortUtil.natSort(a.title, b.title));


radioData.forEach((v) => {
  v.lrcData = findLrc(v.title);
  v.author = v.durationStr;
});

const findFirst = title => (
  title ? radioData.find(v => v.title === title) || radioData[0] : radioData[0]);

export default {
  name: 'App',
  components: {
    VToolbar,
    VBottomNav,
    Aplayer,
    Notebook,
  },
  data: () => {
    const first = findFirst();
    return {
      direction: 'bottom',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-y-reverse-transition',
      drawer: null,
      maxListHeight: '',
      audioInfo: first,
      audioList: radioData,
      playIcon: 'play_arrow',
      playbackRate: 1.0,
      playbackOptions: [
        {
          rate: 1.0,
          color: 'green',
        },
        {
          rate: 0.8,
          color: 'indigo',
        },
        {
          rate: 0.5,
          color: 'red',
        },
      ],
    };
  },
  computed: {
    toolbarType() {
      // return this.isLargeScreen ? 'VToolbar' : 'VBottomNav';
      return this.isLargeScreen ? 'VToolbar' : 'VToolbar';
    },
    lrc() {
      if (this.audioInfo && this.audioInfo.lrcData) {
        const lrcStrReduce = (acc, cur) => {
          acc += cur && cur.alternatives ? `${cur.alternatives[0].transcript}` : '';
          return acc;
        };
        return this.audioInfo.lrcData.results.reduce(lrcStrReduce, '');
      }

      return false;
    },
    isLargeScreen() {
      let type = true;
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          type = false;
          break;
        case 'md':
        case 'lg':
        case 'xl':
        default:
          type = true;
      }

      return type;
    },
  },
  created() {
    this.audioInfo = findFirst(this.$route.params.trackTitle);
  },
  methods: {
    changePlayRate(rate) {
      this.playbackRate = rate;
      this.$refs.player.audio.playbackRate = rate;
    },
    toggle() {
      this.$refs.player.toggle();
    },
    onPlayPause() {
      if (this.$refs.player.audio.paused) {
        this.playIcon = 'play_arrow';
      } else {
        this.playIcon = 'pause';
      }
    },
    updateMusic(mp3) {
      this.$router.push({ name: 'track-item', params: { trackTitle: mp3.title } });
      this.audioInfo = mp3;
      this.playbackRate = 1;
    },
    onResize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          this.maxListHeight = `${window.innerHeight - 110}px`;
          break;
        case 'md':
        case 'lg':
        case 'xl':
        default:
          this.maxListHeight = `${window.innerHeight - 147}px`;
      }
    },
    onended() {
      console.log(this.$refs.player.playIndex);
    },
  },
};
</script>
